import { useEffect, useState } from 'react'
import { Container, Row, Col, Button, Form, Modal, Alert, Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import CheckoutForm from '../CheckoutForm'
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import { AiFillCreditCard } from 'react-icons/ai'
import API from '../../api/api'
import Actions from '../../redux/actions'
import CancelSub from '../CancelSub'

const stripePromise = loadStripe(process.env.NODE_ENV === 'production' ? "pk_live_51Kw3QQFHklCQeNE23WarXvigDO9oSnKcHqJ5WPUGywBefvUUTn4Iz83k3wPfbAAtkb6sUkwnxDi8E5LYYIG9dqpK00jhlEsxll" : "pk_test_51Kw3QQFHklCQeNE2UB78FF0zONs3TtVbz7mu8wzi3UcpjDjEPWfEXk3li2TgtpVBvwDULHu3mrWDb6R8AccaSu8p00xA56Tcen");

export default function Subscription(props) {

    const [editMode, setEditMode] = useState(false)
    const [subAmount, setSubAmount] = useState(0)
    const [subscription, setSubscription] = useState()
    const [nextInvoice, setNextInvoice] = useState()
    const [showCancel, setShowCancel] = useState(false)
    const [quant, setQuant] = useState('')
    const [loading, setLoading] = useState(true)
    const [addMore, setAddMore] = useState(false)
    const [paymentMethods, setPaymentMethods] = useState([])
    const accounts = useSelector(state => state.accounts)
    const user = useSelector(state => state.user)
    const dispatch = useDispatch()
    const [clientSecret, setClientSecret] = useState("");

    useEffect(() => {
        _setup()
        _getClientSecret()
    }, [])

    const _getClientSecret = async () => {
        setLoading(true)
        const res = await API.setupPaymentMethod()
        setClientSecret(res.client_secret)
        setLoading(false)
    }

    const _setup = async () => {
        const data = await API.getSubscription()
        const paymentMethods = await API.getPaymentMethods()
        setPaymentMethods(paymentMethods?.data)
        setNextInvoice(data?.invoice)
        setSubscription(data?.subscription)
        setQuant(data?.subscription?.quantity.toString() || "1")
    }

    const _save = async () => {
        setLoading(true)
        //check to see if too many active licenses
        if (Number(quant) < subscription.quantity) {
            let active = 0
            for (const acc of accounts) {
                active += acc?.devices?.filter(dev => dev.isActive)?.length
            }
            active += user?.devices?.filter(dev => dev.isActive)?.length


            const data = await API.updateSubscription(Number(quant))
            setNextInvoice(data?.invoice)
            setSubscription(data?.subscription)
            setQuant(data?.subscription?.quantity.toString())
            dispatch(Actions.setUser(data.user))
        } else {
            const data = await API.updateSubscription(Number(quant))
            setNextInvoice(data?.invoice)

            setSubscription(data?.subscription)
            setQuant(data?.subscription?.quantity.toString())
            dispatch(Actions.setUser(data.user))

        }
        dispatch(Actions.setToast('Subscription Updated ✅', `You are now allowed ${quant} devices`))
        setLoading(false)
    }

    const _addSubscription = async () => {
        setLoading(true)
        const data = await API.addSubscription(quant)

        setNextInvoice(data?.invoice)
        setSubscription(data?.subscription)
        setQuant(data?.subscription?.quantity.toString())
        dispatch(Actions.setUser(data.user))

        dispatch(Actions.setToast('Subscription Updated ✅', `You are now allowed ${quant + 3} devices`))

        setLoading(false)
    }

    const _stopCancel = async () => {
        setLoading(true)
        const data = await API.stopCancellation()
        setSubscription(data.subscription)
        setNextInvoice(data.invoice)
        dispatch(Actions.setToast('Subscription Restarted ✅', `Your subscription will continue on the end date`))
        setLoading(false)
    }

    const _setPayment = async (e) => {
        if (e.setupIntent.payment_method) {
            const paymentMethod = e.setupIntent.payment_method
            const data = await API.subscribe(Number(quant), false, null, true)
            if (!data.err) {
                await API.updatePaymentMethod(paymentMethod)
                const res = await API.getUser()
                window.location.reload()
            }
        }



    }

    return (
        <>
            <Row className='justify-content-between pb-2 underline mb-4 '>
                <Col md={3} className='text-start'>
                    <h2>Subscription</h2>
                </Col>
                {subscription && !loading && !subscription?.cancel_at_period_end && subscription.status === 'active' && <Col md={6} className='text-end'>
                    {!editMode && <Button variant='primary text-white' onClick={() => setEditMode(true)}>Edit</Button>}
                    {editMode && <Button variant='link noDecoration' onClick={() => { setEditMode(false); setQuant(subscription.quantity) }}>Cancel</Button>}
                    {editMode && <Button variant='primary text-white' disabled={isNaN(quant) || quant === '' || Number(quant) < 1 || !Number.isInteger(Number(quant))} onClick={() => { setEditMode(false); _save() }}>Save</Button>}
                </Col>}
            </Row>
            {user?.isLifeTime && <Row className='p-1'>
                <Col md={3} className='text-start weight-bold'><p>Lifetime Devices: </p></Col>
                <Col md={9}><p><b className='text-primary'>3 </b>Devices</p></Col>
            </Row>}

            {!user?.isLifeTime && !subscription && !loading && <>
                <Row className='p-1'>
                    <Col md={3} className='text-start weight-bold'><p>Number of Devices: </p></Col>
                    <Col md={2} className='mb-3'><Form.Control type='text' value={quant} onChange={e => setQuant(e.target.value)} placeholder='Num Devices' /> </Col>
                    {(isNaN(quant) || quant === '' || Number(quant) < 1 || !Number.isInteger(Number(quant))) && <Col md={7}>
                        <p className='text-primary'>Please enter a valid, whole number greater than 0</p>
                    </Col>}
                    {!(isNaN(quant) || quant === '' || Number(quant) < 1 || !Number.isInteger(Number(quant))) && <Col md={7}>
                        <Row>
                            <Col md={5} className='text-start weight-bold'><p>New Monthly Bill: </p></Col>
                            <Col md={3}><p><b className='text-primary'>${(Number(quant) * 349 / 100).toFixed(2).toLocaleString('en-US')}</b> <small>/ mo</small> </p></Col>
                        </Row>

                    </Col>}
                </Row>
                <Row>
                    <Col md={6} className='mx-auto'>
                        <Elements stripe={stripePromise} options={{ clientSecret: clientSecret }}>
                            <CheckoutForm next={_setPayment} isLifeTime={false} />
                        </Elements>
                    </Col>
                </Row>
       

            </>}
            {user?.isLifeTime && !subscription && !loading && <>


                {addMore && <Row className='p-1'>
                    <Col md={3} className='text-start weight-bold'><p>Number of Devices: </p></Col>
                    <Col md={2} className='mb-3'><Form.Control type='text' value={quant} onChange={e => setQuant(e.target.value)} placeholder='Num Devices' /> </Col>
                    {(isNaN(quant) || quant === '' || Number(quant) < 1 || !Number.isInteger(Number(quant))) && <Col md={7}>
                        <p className='text-primary'>Please enter a valid, whole number greater than 0</p>
                    </Col>}
                    {!(isNaN(quant) || quant === '' || Number(quant) < 1 || !Number.isInteger(Number(quant))) && <Col md={7}>
                        <Row>
                            <Col md={5} className='text-start weight-bold'><p>New Monthly Bill: </p></Col>
                            <Col md={3}><p><b className='text-primary'>${(Number(quant) * 349 / 100).toFixed(2).toLocaleString('en-US')}</b> <small>/ mo</small> </p></Col>
                        </Row>

                    </Col>}
                </Row>}
                {!addMore && <Button onClick={() => setAddMore(true)}>Edit Number of Devices</Button>}
                {addMore && <Button variant='link' onClick={() => setAddMore(false)}>Cancel</Button>}
                {addMore && <Button variant='primary text-white' disabled={isNaN(quant) || quant === '' || Number(quant) < 1 || !Number.isInteger(Number(quant))} onClick={() => { _addSubscription() }}>Confirm</Button>}

            </>
            }

            {loading && <div className='text-center'><Spinner animation='border' /></div>}

            {/* ACTIVE SUBSCRIPTION*/}
            {subscription && !loading && !subscription?.cancel_at_period_end && subscription.status === 'active' && <>
                <Row className='p-1'>
                    <Col md={3} className='text-start weight-bold'><p>Number of {user?.isLifeTime && 'Subscription '}Devices: </p></Col>
                    {!editMode && <Col md={9}><p><b className='text-primary'>{subscription.quantity}</b> devices</p></Col>}
                    {editMode && <Col md={2} className='mb-3'><Form.Control type='text' value={quant} onChange={e => setQuant(e.target.value)} placeholder='Num Devices' /> </Col>}
                    {editMode && (isNaN(quant) || quant === '' || Number(quant) < 1 || !Number.isInteger(Number(quant))) && <Col md={7}>
                        <p className='text-primary'>Please enter a valid, whole number greater than 0</p>
                    </Col>}
                    {editMode && !(isNaN(quant) || quant === '' || Number(quant) < 1 || !Number.isInteger(Number(quant))) && <Col md={7}>
                        <Row>
                            <Col md={5} className='text-start weight-bold'><p>New Monthly Bill: </p></Col>
                            <Col md={3}><p><b className='text-primary'>${(Number(quant) * 349 / 100).toFixed(2).toLocaleString('en-US')}</b> <small>/ mo</small> </p></Col>
                        </Row>

                    </Col>}
                </Row>
                <Row className='p-1'>
                    <Col md={3} className='text-start weight-bold'><p>Base Subscription Cost</p></Col>
                    <Col md={9}><p><b className='text-primary'>${(subscription.quantity * 349 / 100).toFixed(2)}</b> <small>/ mo</small> </p></Col>
                </Row>
                <Row className='p-1'>
                    <Col md={3} className='text-start weight-bold'><p>Next Month's Charge</p></Col>
                    <Col md={9}><p className='mb-0'><b className='text-primary'>${(nextInvoice?.amount_due / 100).toFixed(2)}</b> <small>/ mo</small> <br /><small className='mb-2'><i>(This may be different than the rate above if you added or removed devices this month)</i></small> </p>
                    </Col>
                </Row>
                <Row className='p-1 mt-1'>
                    <Col md={3} className='text-start weight-bold'><p>Renews On</p></Col>
                    <Col md={9}><p>{new Date(subscription.current_period_end * 1000).toLocaleDateString('en-US', { dateStyle: 'full' })}</p></Col>
                </Row>
                <Row className='p-1'>
                    <Col md={3} className='text-start weight-bold'><p>Started On</p></Col>
                    <Col md={9}><p >{new Date(subscription.created * 1000).toLocaleDateString('en-US', { dateStyle: 'medium' })}</p></Col>
                </Row>
                <div className='text-center'>
                    {editMode && <Button variant='link noDecoration text-secondary ps-0 ms-0' onClick={() => setShowCancel(true)} >Cancel Subscription</Button>}
                </div>

            </>}
            {/* CANCELLING SUBSCRIPTION*/}
            {subscription && !loading && subscription?.cancel_at_period_end && subscription.status === 'active' && <>
                <p className='text-center text-primary weight-bold'>You cancelled your subscription!</p>

                <Row className='p-1'>
                    <Col md={3} className='text-start weight-bold'><p>Number of Devices: </p></Col>
                    <Col md={9}><p><b className='text-primary'>{subscription.quantity}</b> devices</p></Col>

                </Row>

                <Row className='p-1 mt-1'>
                    <Col md={3} className='text-start weight-bold'><p>Ends On</p></Col>
                    <Col md={9}><p>{new Date(subscription.current_period_end * 1000).toLocaleDateString('en-US', { dateStyle: 'full' })}</p></Col>
                </Row>
                <div className='text-center'>
                    <Button variant='primary' onClick={_stopCancel}>Renew Subscription</Button>
                </div>
            </>}


            {/* CANCELLING SUBSCRIPTION*/}
            {subscription && !loading && subscription.status === 'canceled' && <>
                <p className='text-center text-primary weight-bold'>Your subscription ended on {new Date(user?.lastDate).toLocaleDateString('en-US', { dateStyle: 'long' })}!</p>
                <div className='text-center'>
                    <Button variant='primary' >Create New Subscription</Button>
                </div>
            </>}

            {!loading && paymentMethods.length > 0 &&
                <Row className='p-1'>
                    <Col md={3} className='text-start weight-bold'><p>Payment Method: </p></Col>
                    <Col md={9}> <span><AiFillCreditCard className='text-primary me-2' size='1.5rem' /></span>{paymentMethods[0].card?.brand?.toUpperCase()}   <sup className='ms-3'>*</sup>{paymentMethods[0].card?.last4} </Col>
                </Row>}



            <Modal show={showCancel} onHide={() => setShowCancel(false)} size='md'>
                <Modal.Header closeButton>
                    <Modal.Title>Cancel Subscription</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CancelSub close={() => setShowCancel(false)} saveSub={sub => setSubscription(sub)} />
                </Modal.Body>

            </Modal>

            <p className='text-center mt-3'><small>Email <a href='mailto:support@scamwall.io'>support@scamwall.io</a> if you have any issues with billing</small></p>
        </>
    )

}